<template>
  <div class="passengers-list">
    <form @submit.prevent="submitSeatMapDeparture">
      <h1 id="wb-cont" class="container">{{ $t('seatSelectionDeparture') }}</h1>
      <div class="container">
        <div class="seatmap-legend">
          <ul>
            <li>
              <span class="legend-blue">{{ $t('seatmapbluelabel') }}</span>
              - {{ $t('seatmaplegend1') }}
            </li>
            <li>{{ $t('seatmaplegend2') }}</li>
            <li>{{ $t('seatmaplegend3') }}</li>
          </ul>
        </div>
      </div>
      <div class="container">
        <div role="list" class="passenger-list col-xs-12">
          <seatMapPassenger v-for="(passenger, index) in passengers" :key="'Passenger' + index" :passenger="passenger"
            :index="index" :tripId="departureTripItem.id" />
        </div>
      </div>
      <div class="container seatmap-section-wrapper">
        <div class="seatmap-section" v-for="section in getDepartureSeatmapSections" :key="section._id">
          <div class="section-has-rows" v-if="section.rows.length">
            <h2>{{ section.label }}</h2>
            <div class="section-rows">
              <div class="section-row" v-for="row in section.rows" :key="section._id + 'Row' + row.label">
                <!--<p class="row-label">{{ row.label }}</p>-->
                <template v-if="departureTripItem.hasOwnProperty('segments')">
                  <seatMapSeat :seat="seat" :row="row" :section="section"
                  :seatMapId="departureTripItem.segments[0].seatMapId" :scheduleId="departureTripItem.segments[0].name"
                  :tripId="departureTripItem.id" v-for="seat in row.seats" :key="seat.id" />
                  </template>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="form-group text-center mini-widget--actions">
        <a href="#" class="btn btn-ghost btn-ghost-yellow mrgn-rght-md" @click.prevent="modifyTrip">{{ $t('modifytrip') }}</a>
        <button type="submit" id="tripNext" class="btn btn-primary">{{ $t('next') }}</button>
      </div>
    </form>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import seatMapPassenger from "../components/seatMapPassenger.vue";
import seatMapSeat from "../components/seatMapSeat.vue";
export default {
  name: "PassengerSeatMap",
  components: {
    seatMapPassenger,
    seatMapSeat
  },
  data() {
    return {
      errors: [],
      currentPassenger: "",
      seatErrors: []
    };
  },
  watch: {},
  created() {
    this.$store.commit("getSeatMap");
    if (!this.passengers[0].seats.length) {
      this.$store.commit("setSeatMapActivePassenger", 0);
    }
  },
  computed: {
    errorList() {
      const errorList = this.$refs.observer.validate();
      return errorList;
    },
    activePassenger() {
      return this.$store.state.seatMapActivePassenger;
    },
    ...mapState([
      "passengers",
      "departureTripItem",
      "returnTripItem",
      "departureSeatMap",
      "returnSeatMap"
    ]),
    ...mapGetters(["getDepartureSeatmapSections"])
  },
  methods: {
    modifyTrip: function () {
      this.$router.back();
    },
    submitSeatMapDeparture: function () {
      // eslint-disable-next-line
      let numSelections = jQuery(".js-passengerseat").length;
      let numPassengers = this.passengers.length;
      if (numSelections == numPassengers) {
        if (this.returnSeatMap) {
          this.$store.commit("setSeatMapActivePassenger", 0);
          this.$router.push("/trips/passengers/seats/return");
        } else {
          this.$store.dispatch("addToCartShowCart").then(() => {
            this.$router.push("/cart");
          }).catch(({ response }) => {
            // Let the user know something didn't work.
            if (response.data.code == 'SEAT_TAKEN') {
              this.$store.commit("REMOVE_SEAT_SELECTIONS");
              alert('One of the seats you selected is no longer available, please select different seats and try again.');
            } else {
              alert(response.data.message);
            }

          });
        }
      } else {
        alert("You must select seats for all passengers.");
      }
    },
    realErrors(obj) {
      for (var propName in obj) {
        if (
          obj[propName] === null ||
          obj[propName] === undefined ||
          !obj[propName].length
        ) {
          delete obj[propName];
        }
      }
      return obj;
    },
    countErrors: function (errors) {
      const errorCount = Object.values(errors);
      let count = 0;
      for (let i = 0; i < errorCount.length; i++) {
        if (errorCount[i].length) {
          count++;
        }
      }
      return count;
    }
  },
  filters: {}
};
</script>
<style lang="scss">
.flex-container {
  display: flex;
  justify-content: space-between;
}

.legend-blue {
  background-color: $brand-primary;
  padding: 2px 5px;
  border-radius: 5px;
  color: #fff;
}

.section-rows {
  display: flex;
}

.seatmap-section-wrapper {
  display: flex;
  flex-wrap: wrap;
  row-gap: 20px;
}

.row-label {
  text-align: center;
  background: #efefef;
  border-radius: 50%;
}

.section-has-rows {
  padding-right: 20px;
}

.section-row {
  padding-right: 5px;
}

.seatmap-section .seatmap-section-row-seat {
  height: 22px;
  width: 24px;
  font-size:12px;
  background-color: #cecece;
  border-radius: 5px;
  margin-bottom: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.seatmap-section .seatmap-section-row-seat.gap {
  background-color: #fff;
  height: 22px;

  span {
    display: none;
  }
}

.seatmap-section .seatmap-section-row-seat.reserved,
.seatmap-section .seatmap-section-row-seat.occupied {
  opacity: 0.7;

  a {
    cursor: not-allowed;
  }
}

.seatmap-section .seatmap-section-row-seat.reserved span {
  display: none;
}

// .seatmap-section .seatmap-section-row-seat.reserved:before {
//   content: "X";
// }
.seatmap-section .seatmap-section-row-seat.blocked {
  opacity: 0.7;
  background-color: #b3b1b1;
  cursor: not-allowed;
}

.seatmap-section .seatmap-section-row-seat.selected {
  background-color: green;
  color: silver;
}

.seatmap-section .seatmap-section-row-seat.taken {
  background-color: red;
  color: silver;
}

.seatmap-section .seatmap-section-row-seat.open {
  background-color: #febc11;
  color: $brand-primary;

  a {
    color: $brand-primary;
  }
}
.seatmap-section .seatmap-section-row-seat.accessible {
  background-color:#0061bde3;
  a{
    color:transparent!important;
  }
}
.seatmap-section .seatmap-section-row-seat.accessible::before{
    content: "\f193";
    font-family: fontawesome;
    color: #fff;
    position: absolute;
    font-size: 1em;
}

.seatmap-section .seatmap-section-row-seat.seatIsSelected {
  background-color: green !important;

  a {
    color: #fff;
  }
}

.seatmap-section .seatmap-section-row-seat.emergency-seat {
  background-color: $brand-primary;
  color: #fff;

  a {
    color: #fff;
  }
}
</style>